import { useState } from 'react';
import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  const [errors, setErrors] = useState<Record<number, boolean>>();

  const handleError = (index: number) => {
    setErrors((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <section id="media" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-primary-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">精彩视频</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">3部热门精选</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item, index) => (
            <div
              key={index}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all"
            >
              <div className="relative aspect-[16/10] bg-background-100 overflow-hidden">
                {!errors[index] ? (
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => handleError(index)}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-background-100">
                    <div className="text-center">
                      <i className="ri-film-line text-5xl text-foreground-300 mb-2" />
                      <p className="text-sm text-foreground-400">{item.tag}</p>
                    </div>
                  </div>
                )}

                <div className="absolute inset-0 bg-black/25 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer">
                  <div className="w-16 h-16 rounded-full bg-background-50/90 flex items-center justify-center backdrop-blur-sm">
                    <div className="w-7 h-7 flex items-center justify-center text-primary-500">
                      <i className="ri-play-fill text-3xl" />
                    </div>
                  </div>
                </div>

                <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-semibold bg-accent-500 text-background-50 rounded-full">
                  {item.tag}
                </span>

                <span className="absolute bottom-3 right-3 px-2.5 py-1 text-[11px] font-medium bg-black/60 text-background-50 rounded-full backdrop-blur-sm">
                  {item.duration}
                </span>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line" />
                    </div>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}